import { CustomFieldType } from '../fields/custom.field.type';

export interface BrcFieldCapability {
    filterable: boolean;
    groupable: boolean;
}

const CUSTOM_FIELD_CAPABILITY: Partial<Record<CustomFieldType, BrcFieldCapability>> = {
    [CustomFieldType.Dropdown]: { filterable: true, groupable: true },
    [CustomFieldType.DropdownMulti]: { filterable: true, groupable: true },
    [CustomFieldType.Boolean]: { filterable: true, groupable: false },
    [CustomFieldType.Number]: { filterable: true, groupable: true },
    [CustomFieldType.Text]: { filterable: true, groupable: true },
    [CustomFieldType.Date]: { filterable: true, groupable: false },
    [CustomFieldType.DateTime]: { filterable: true, groupable: false },
};

export function getBrcCustomFieldCapability(type: CustomFieldType): BrcFieldCapability {

    return CUSTOM_FIELD_CAPABILITY[type] ?? { filterable: false, groupable: false };
}
